module.exports = __webpack_public_path__ + "media/images/covid/menu/icon-8923bec89b706c58bafa20b1ab765e4d.png";